import { GET_CLIENT_SECRET_BY_COMPANY_ID } from "../constants";
import { ApiCall } from "../../utils/index"

export const getClientSecret = (cb, debouncedHandleSearch, page, row_count, sortField, sortOrder) => async (dispatch, getState) => {
  try {
    const {
      auth: { token },
    } = getState();

    let url = "/client-secret"

    if(page) {
      const searchParam = debouncedHandleSearch ? `search=${debouncedHandleSearch}&` : "";
      const params = `?${searchParam}page=${page}&page_size=${row_count}&sort_by=${sortField}&sort_order=${sortOrder}`;
      url = url + params
    }

    const result = await ApiCall.get(url, token);

    dispatch({
      type: GET_CLIENT_SECRET_BY_COMPANY_ID,
      payload: result.data,
    });
    cb(result);
  } catch (error) {
    cb(error);
  }
};

export const createClientSecret =
  (payload, cb) => async (dispatch, getState) => {
    try {
      const {
        auth: { token },
      } = getState();
      const result = await ApiCall.post("/client-secret/", payload, token);
  
      cb(result);
    } catch (error) {
      cb(error);
    }
  };

export const deleteClientSecret = (id, cb) => async (dispatch, getState) => {
  try {
    const {
      auth: { token },
    } = getState();
    const result = await ApiCall.delete(`/client-secret/${id}`, token);

    cb(result);
  } catch (error) {
    cb(error);
  }
};
